export default __webpack_public_path__ + "static/media/Decision maker 2.cf6eb824.mp3";